import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    expandWorkspace: string;
    collapseWorkspace: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for expand workspace button */
            expandWorkspace: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CollapseTrigger.expandWorkspace?c=3gaj69obpch", defaultMessage: "Expand workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for collapse workspace button */
            collapseWorkspace: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CollapseTrigger.collapseWorkspace?c=1ezdgl99t92pr", defaultMessage: "Collapse workspace" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
